import { GeolocationApiResponse } from "@silversea-ssc/dotcom-api-types/Geolocation";
import { sanityClient } from "../client";
import { match } from "ts-pattern";
import {
  authorsIndexName,
  postsIndexName,
  videosIndexName
} from "@repo/algolia/client";

type AlgoliaArea = GeolocationApiResponse["algoliaArea"];

//import { algoliaCruiseIndexName } from "@silversea-ssc/dotcom-api-types/AlgoliaSchema";
const algoliaCruiseIndexName = (stage: string, area: AlgoliaArea) =>
  `${stage}_cruises_${area}`;

export const cruiseSearchIndexName = (algoliaArea: AlgoliaArea) =>
  algoliaCruiseIndexName(
    process.env.NEXT_PUBLIC_CRUISE_ALGOLIA_ENV || "production",
    algoliaArea
  );

export type AlgoliaIndexType = "posts" | "authors" | "videos";
export const algoliaIndexNameFor = (indexType: AlgoliaIndexType) => {
  const sanityDataset = sanityClient.config().dataset;
  return match(indexType)
    .with("posts", () => postsIndexName(sanityDataset))
    .with("authors", () => authorsIndexName(sanityDataset))
    .with("videos", () => videosIndexName(sanityDataset))
    .exhaustive();
};
